import {BackgroundToolboxOptions, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalAddBackground} from "./PortalAddBackground";

export enum BackgroundFunction {
	ADD = "add",
	REMOVE = "remove"
}

export class PortalBackgroundToolboxOptions extends BackgroundToolboxOptions implements Parameter {
	public mode?: BackgroundFunction;

	constructor(data: any) {
		super(data);

		this.add = PortalAddBackground.fromJson(data?.add);
		this.mode = FunctionHelper.exists(data?.mode) ? data.mode : BackgroundFunction.ADD;
	}

	public static getModeDefault(): BackgroundFunction {
		return BackgroundFunction.ADD;
	}

	public static fromJson(data: any): PortalBackgroundToolboxOptions {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalBackgroundToolboxOptions(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'mode': this.mode
		};
	}

	public clone(): PortalBackgroundToolboxOptions {
		return PortalBackgroundToolboxOptions.fromJson(this.toJson());
	}
}